import { useTranslation } from 'react-i18next';
import { blokkieTheme } from '@tikkie/blokkie';

import recyclingCansImg from '@/assets/imgs/recycling-cans.png';
import type { MultiSizeImage } from '@/types/campaign';

type CampaignLandingImageProps = {
  image?: MultiSizeImage;
};

export function CampaignLandingImage({ image }: CampaignLandingImageProps) {
  const { t } = useTranslation(['translation', 'a11y']);

  const imageUrls = {
    small: image?.small?.trim(),
    medium: image?.medium?.trim(),
    large: image?.large?.trim(),
  };
  const firstAvailableCampaignImage =
    imageUrls.small || imageUrls.medium || imageUrls.large;

  const hasCampaignImage = Boolean(firstAvailableCampaignImage);
  const imageSources = {
    small: imageUrls.small || firstAvailableCampaignImage || recyclingCansImg,
    medium: imageUrls.medium || firstAvailableCampaignImage || recyclingCansImg,
    large: imageUrls.large || firstAvailableCampaignImage || recyclingCansImg,
  };

  const imageAlt =
    (hasCampaignImage && image?.label?.trim()) ||
    t('landing.imgs.recyclingCans');

  return (
    <div style={{ height: '19rem' }}>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <picture>
          {hasCampaignImage && (
            <>
              <source
                data-testid="campaign-landing-image-source-large"
                media={`(min-width: ${blokkieTheme.breakpoints.tablet.min}px)`}
                srcSet={imageSources.large}
              />
              <source
                data-testid="campaign-landing-image-source-medium"
                media={`(min-width: ${blokkieTheme.breakpoints.mediumPhone.min}px)`}
                srcSet={imageSources.medium}
              />
            </>
          )}
          <img
            data-testid="campaign-landing-image"
            src={imageSources.small}
            alt={imageAlt}
            style={{
              height: '18em',
              opacity: 0.5,
              position: 'relative',
              marginTop: '1rem',
            }}
          />
        </picture>
      </div>
    </div>
  );
}
